import { isCurveVertex } from '@i-ark/models';
import { extractBoundingBoxFromPolygonVertices } from '@i-ark/utils';
import { transformPlacementToVertices } from '../transformPlacementToVertices.js';

const transformShapeV1ToLegacyCanvasShapeV2 = (shape, aspectRatio, pageIndex, index, supportedShapeColoring) => {
  const baseShape = {
    id: `${pageIndex.toString()}_legacyCanvasShape-${index.toString()}`,
    settings: {
      cloneable: shape.duplicateAble ?? false,
      movable: shape.moveAble ?? false,
      hideDragHandle: true
    },
    style: transformStyles(shape, supportedShapeColoring)
  };
  switch (shape.type) {
    case "polygon": {
      const vertices = transformPlacementToVertices(shape.placement);
      const boundingBox = extractBoundingBoxFromPolygonVertices(vertices);
      return {
        ...baseShape,
        kind: "legacyCanvasShape",
        type: shape.type,
        position: { x: boundingBox.left, y: boundingBox.top },
        angleInRadian: 0,
        size: {
          width: boundingBox.width,
          height: boundingBox.height
        },
        naturalSize: {
          width: boundingBox.width,
          height: boundingBox.height * aspectRatio
        },
        vertices: normalizePolygonVertices(vertices, boundingBox)
      };
    }
    case "circle": {
      const [originX, originY] = shape.placement;
      const width = shape.size / 100 * 2;
      const height = width / aspectRatio;
      return {
        ...baseShape,
        kind: "legacyCanvasShape",
        type: shape.type,
        radius: width / 2,
        position: {
          x: originX / 100 - width / 2,
          y: originY / 100 - height / 2
        },
        angleInRadian: 0,
        size: {
          width,
          height
        },
        naturalSize: {
          width,
          height: height * aspectRatio
        }
      };
    }
    case "rectangle": {
      const [x, y] = shape.placement;
      const width = shape.width / 100;
      const height = shape.height / 100;
      return {
        ...baseShape,
        kind: "legacyCanvasShape",
        type: shape.type,
        position: {
          x: x / 100,
          y: y / 100
        },
        angleInRadian: 0,
        size: {
          width,
          height
        },
        naturalSize: {
          width,
          height: height * aspectRatio
        }
      };
    }
    default:
      throw new Error("unable to resolve canvasShape");
  }
};
function normalizePolygonVertices(vertices, boundingBox) {
  return vertices.map((vertex) => {
    const transformedVertex = {
      coordinate: {
        x: normalizePoint(
          vertex.coordinate.x,
          boundingBox.left,
          boundingBox.right
        ),
        y: normalizePoint(
          vertex.coordinate.y,
          boundingBox.top,
          boundingBox.bottom
        )
      }
    };
    if (isCurveVertex(vertex)) {
      transformedVertex.curve = {
        x: normalizePoint(vertex.curve.x, boundingBox.left, boundingBox.right),
        y: normalizePoint(vertex.curve.y, boundingBox.top, boundingBox.bottom)
      };
    }
    return transformedVertex;
  });
}
function normalizePoint(point, min, max) {
  return (point - min) / (max - min);
}
function transformStyles(shape, supportedShapeColoring) {
  const backgroundColor = supportedShapeColoring ? shape.background !== "" && shape.background !== "transparent" ? shape.background : "#888" : shape.background;
  return {
    stroke: {
      type: shape.stroke.type,
      color: shape.stroke.color,
      width: Number(shape.stroke.size)
    },
    background: {
      color: backgroundColor,
      opacity: shape.backgroundOpacity / 100
    }
  };
}

export { transformShapeV1ToLegacyCanvasShapeV2 };
//# sourceMappingURL=transformShapeV1ToLegacyCanvasShapeV2.js.map
